<template>
    <modal name="LevelHistoryModal"
           transition="nice-modal-fade"
           :min-width="360"
           :min-height="150"
           :pivot-y="0.4"
           :adaptive="true"
           :reset="true"
           height="auto">
        <div class="popupcontainer vue-dialog">
            <div class="btn-close">
                <svg width="14px" height="14px" viewBox="0 0 12 12" xmlSpace="preserve" @click="close()">
                    <line x1="1" y1="11" x2="11" y2="1" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                    <line x1="1" y1="1" x2="11" y2="11" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                </svg>
            </div>
            <div class="modalHeader">
                <h4>
                    활동 / 봉사시간 기록
                </h4>
            </div>


            <div style="margin-left: 20px;" class="modal-body">
                <AlarmList :msgOnly="true" :memberId="id"></AlarmList>

            </div>
            <div class="vue-dialog-buttons">
                <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click="close()">닫기</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import AlarmList from '@/components/member/AlarmList.vue'

    export default {
        name: "LevelHistoryModal",
        components: {
            AlarmList
        },
        props: {
            userId: Number,
        },
        data() {
            return {
                nowMemo : ''
            }
        },
        computed: {
            id: {
                get() {
                    return this.userId;
                },
                set(newVal) {
                    this.id = newVal
                }
            }
        },
        methods: {
            apply() {
                this.close();
            },
            close() {
                this.$modal.hide('LevelHistoryModal')
            },
        },
        mounted() {
        },
        created() {
        },
    }
</script>

<style scoped>
    .popupcontainer {
        overflow-y: auto;
        border-radius: 5px;
        background: #F7F7F7;
        max-height: 600px;
    }
    .btn-close {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .btn-close line {
        stroke: grey;
        stroke-width: 2;
    }
    .btn-close:hover line {
        stroke: black;
    }
    .modalHeader {
        border-bottom: 1px solid #EEE;
        padding: 1em;
        text-align: left;
    }

</style>